import axios from "axios";
import { BASE_API_URL } from "../consts";

export type SupplierType = "self" | "restaurant" | "catering" | "other";

export const SUPPLIER_TYPE_LABEL: Record<SupplierType, string> = {
  self: "Vlastita kuhinja",
  restaurant: "Restoran",
  catering: "Catering",
  other: "Ostalo",
};

export const SUPPLIER_TYPE_ICON: Record<SupplierType, string> = {
  self: "👨‍🍳",
  restaurant: "🍴",
  catering: "🚐",
  other: "📦",
};

export interface ClientSupplier {
  _id: string;
  clientId: string;
  name: string;
  type: SupplierType;
  phone?: string | null;
  note?: string | null;
  isActive: boolean;
  archived?: boolean;
  createdAt: string;
  updatedAt: string;
}

// Embedded in ClientMeal
export interface MealSupplierLink {
  supplierId: string | ClientSupplier;
  name: string;      // snapshot
  isActive: boolean;
}

export const getSuppliers = (clientId: string) =>
  axios.get<ClientSupplier[]>(`${BASE_API_URL}/${clientId}/apt-suppliers`);

export const createSupplier = (clientId: string, data: Partial<ClientSupplier>) =>
  axios.post<ClientSupplier>(`${BASE_API_URL}/${clientId}/apt-suppliers`, data);

export const updateSupplier = (id: string, data: Partial<ClientSupplier>) =>
  axios.put<ClientSupplier>(`${BASE_API_URL}/apt-suppliers/${id}`, data);

export const deleteSupplier = (id: string) =>
  axios.delete(`${BASE_API_URL}/apt-suppliers/${id}`);
